import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { config } from "core/utils";
import LoadExternalScript from "./LoadExternalScript";
var CurartorFeed = function (props) {
    var id = props.id, container = props.container;
    var _a = useState(false), scriptLoaded = _a[0], setScriptLoaded = _a[1];
    var _b = useState(false), widgetLoaded = _b[0], setWidgetLoaded = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-undef
        if (window.Curator !== undefined) {
            // This is needed because the Curator widget appends
            // which causes the widget to be rendered multiple times
            // if the code below is executed multiple times
            if (ref.current)
                ref.current.innerHTML = "";
            // Render widget
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
            var widget = new Curator.Widgets.Waterfall({
                debug: config.legoMasters.curator.debug,
                container: "#".concat(container),
                feedId: id,
            });
            setWidgetLoaded(true);
        }
    }, [scriptLoaded, widgetLoaded]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("link", { href: config.legoMasters.curator.cssUrl, key: config.legoMasters.curator.cssUrl, rel: "stylesheet", type: "text/css" })),
        React.createElement(LoadExternalScript, { src: config.legoMasters.curator.jsUrl, id: "example", onLoad: function () { return setScriptLoaded(true); } }),
        React.createElement("div", { id: container, ref: ref })));
};
export default CurartorFeed;
